export default class OpenTag {
  static applictions = {
    show: 'gh_08398972343c', // 暄桐展览
    show_trial: 'gh_bcfc93da5e27',
    wenfang: 'gh_79c64ca9ccaf', // 暄桐文房
    daycourse: 'gh_6df4e6c6d0bc', // 暄桐日课
    uc: 'gh_2f751118256c',
    uc_trial: 'gh_b4770161fac9',
    arts: 'gh_303531a14c15' // 山林
  }
  static appids = {
    show: 'wxa7a480615c0324ac', // 暄桐展览
    wenfang: 'wx64d682e31d37f90f', // 暄桐文房
    daycourse: 'wx93b2a004dd8c3990', // 暄桐日课
    uc: 'wx44a132db3c5f5042', // uc
    arts: 'wxdd8e4cede634b355' // 山林
  }
  static testApplictionsShow = 'gh_bcfc93da5e27'
  //后期这块不维护
  static ways = {
    show_home_page: '/pages/index/index', // 展览首页
    show_painting: '/pages/lookingEx/index', // 观展
    show_painting_detail: '/pages/exhibits/detail/index', // 参展
    wenfang_equipment_and_vouchers: '/pages/common/blank-page/index', // 全阶活动——买单品  我的积分——用文房券
    wenfang_dashboard: '/pages/home/dashboard/index', // 文房模块
    my_point_bind_vouchers: '/pages/usercenter/dashboard/index', // 我的积分——绑定文房券 & 查看实时状态
    fullstage_course_detail: '/packages/goods/detail/index', // 全阶活动详情——文房装备
    activity_daycourse: '/pages/user/my/my' // 暄桐日课
  }
  //展览
  static showPath = {
    show_home_page: '/pages/index/index', // 展览首页
    show_painting: '/pages/lookingEx/index', // 展览书画1-3 5
    show_painting_detail: '/pages/exhibits/detail/index', // 展览书画4
    show_ready: '/pages/levels/index'
  }
  //文房小程序
  static wenfangPath = {
    wenfang_equipment_and_vouchers: '/pages/common/blank-page/index', // 全阶活动——买单品  我的积分——用文房券
    wenfang_dashboard: '/pages/home/dashboard/index', // 文房模块
    fullstage_course_detail: '/packages/goods/detail/index' // 全阶活动详情——文房装备
  }
  //鲸打卡
  static whaleClockIn = {
    my_point_bind_vouchers: '/pages/usercenter/dashboard/index', // 我的积分——绑定文房券 & 查看实时状态
    experience: '/pages/user_homework/homework_list/homework_list?courseId=1304149&type=redirect',
    activity_daycourse: '/pages/user/my/my' // 暄桐日课
  }
}
